import React, { useState, useEffect } from "react";
import "../../style/Plans/Scopri/_Tradizionale.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as SadFace } from "../../assets/new-icons/tradizionaleFace.svg";
import { ReactComponent as Assistenza } from "../../assets/new-icons/assistenza.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import Step2 from "../../components/PianiDisponibili/Tradizionale/Step2";
import Step3 from "../../components/PianiDisponibili/Tradizionale/Step3";
import PersonaTradizionale from "../../assets/img/personaTradizionale.png";
import Assistence from "../../components/SideNav/Assistence";

function Tradizionale() {
  const navigate = useNavigate();
  const currentPlan = useSelector((user) => user?.user?.idGruppo);
  const [next, setNext] = useState(0);
  const saldoNegativo = useSelector(
    (user) => user.user.nuoviDatiContratto.mono_negativo
  );
  const opzioneTariffaria = useSelector(
    (user) => user.user.info.opzione_tariffaria
  );
  const quotaFissaNeg = useSelector(
    (user) => user.user.nuoviDatiContratto.qf_negativo
  );
  const [scroll, setScroll] = useState(false);
  const [assistenceOpen, setAssistenceOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0)
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > window.innerHeight / 3
      if (scrollCheck) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    });
  }, []);

  const getPlanName = () => {
    switch (currentPlan) {
      case 1:
        return "Ricaricabile";
      case 2:
        return "Relax";

      case 3:
        return "Tradizionale";
      default:
        break;
    }
  };
  const nextStep = () => {
    setNext(next + 1);
  };
  const previusStep = () => {
    setNext(next - 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    assistenceOpen ? document.body.style.overflow = 'hidden' : document.body.style.overflow = null
    assistenceOpen ? document.body.style.touchAction = 'none' : document.body.style.touchAction = null
  },[assistenceOpen])
  return (
    <div className={`tradizionale ${next !== 0 ? 'steps' : null}`}>
      <div
        className="tradizionale-top"
        style={next !== 0 ? { minHeight: "70px", marginBottom: "0px", backgroundColor: "#fff" } : null}
      >
        {
          next !== 0 ? null : (
            <header>
              <div
                className="navigation"
                onClick={() => (next === 0 ? navigate(-1) : previusStep())}
              >
                <ArrowBackIcon />
              </div>
              <div className="assistence" onClick={() => setAssistenceOpen(true)}>
                <Assistenza />
              </div>

            </header>
          )
        }
        {
          scroll || next !== 0 ? (
            <header className={scroll || next !== 0 ? "fixed" : null}>
              <div
                className="navigation"
                onClick={() => (next === 0 ? navigate(-1) : previusStep())}
              >
                <ArrowBackIcon />
                {next !== 0 ? (
                  <div className="recap">
                    <p className="secondary epilogue">Da {getPlanName()} a</p>
                    <p className="main epilogue">Tradizionale</p>
                  </div>
                ) : null}
              </div>
              {next !== 0 ? (
                <div className="pagination">
                  <span className={next === 1 ? "active" : ""}></span>
                  <span className={next === 2 ? "active" : ""}></span>
                </div>
              ) : (
                <div className="assistence" onClick={() => setAssistenceOpen(true)}>
                  <Assistenza />
                </div>
              )}
            </header>
          ) : null
        }
        {next === 0 ? (
          <div className="text">
            <div className="icon">
              <SadFace />
            </div>
            <p className="secondary">Tradizionale</p>
            <p className="main epilogue">Ricarica una volta al mese</p>
          </div>
        ) : null}
      </div>
      {next === 0 ? (
        <div className="tradizionale-bottom">
          <p className="info">
            Il piano tradizionale è pensato per te che desideri pagare i consumi
            alla scadenza naturale della fattura.
          </p>
          <p className="info">
            Non anticipi il pagamento e non ottieni nessun bonus ( quindi paghi
            il prezzo al kWh standard di listino. )
          </p>
          <div className="priceBox">
            <p className="label">Prezzo</p>
            <p className="sulLabel">Applicato su tutti i consumi</p>
            <div className="neutral">
              <p className="price">
                {parseFloat(saldoNegativo).toFixed(2).replace(/\./g, ",")}
                <span> €/kWh </span>{" "}
                {opzioneTariffaria && opzioneTariffaria !== "D2" ? (
                  <span className="quotaFissa">
                    +{parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")}€
                    al giorno
                  </span>
                ) : null}
              </p>
              {opzioneTariffaria &&
                opzioneTariffaria !== "D2" &&
                opzioneTariffaria !== "D3" ? (
                <p className="iva">IVA da aggiungere</p>
              ) : null}
            </div>
            <p className="plus">
              Non sono previsti sconti o bonus per il piano Tradizionale.
            </p>
          </div>
          <div className="column">
            <div className="customRow">
              <p className="main">Cosa paghi?</p>
              <span className="separ"></span>
              <p className="secondary">
                Prezzo al kWh tutto incluso x consumi mensili
              </p>
            </div>
            <div className="customRow">
              <p className="main">Hai sconti?</p>
              <span className="separ"></span>
              <p className="secondary">Nessuno</p>
            </div>
            <div className="customRow">
              <p className="main">Quando paghi i consumi del mese?</p>
              <span className="separ"></span>
              <p className="secondary">
                Tra il 15 e il 20 del mese successivo a quello dei consumi
              </p>
            </div>
            <div className="customRow">
              <p className="main">Tempistiche di attivazione</p>
              <span className="separ"></span>
              <p className="secondary">
                Se scegli oggi il piano Tradizionale, sarà attivo dal{" "}
                {DateTime.now()
                  .plus({ month: +1 })
                  .toFormat("01/MM/yyyy")}
              </p>
            </div>
          </div>
          <div className="buttonActivate">
            <button onClick={() => nextStep()}>
              Passa al piano Tradizionale{" "}
              <ArrowForwardIosIcon fontSize="18px" />
            </button>
          </div>
        </div>
      ) : next === 1 ? (
        <div className="steps">
          <Step2 next={() => nextStep()} />
        </div>
      ) : (
        <div className="steps">
          <Step3 next={() => nextStep()} />
        </div>
      )}
    </div>
  );
}

export default Tradizionale;
